import dayjs from 'dayjs';
import isTomorrow from 'dayjs/plugin/isTomorrow';

dayjs.extend(isTomorrow);

export default function isDateTomorrow(date?: dayjs.Dayjs | null): boolean {
  if (!date) {
    return false;
  }

  return dayjs(date).isTomorrow();
}
